import 'reflect-metadata';
import { plainToClass } from "class-transformer";
import { DrawCabinet } from '$src/CGS/domain/dto/article/Cabinet/DrawCabinet';
import { CabinetGeneratorFactory } from '../../Cabinet/CabinetGeneratorFactory ';
import { CabinetObject } from '../../Cabinet/Objects/CabinetObject';

export class CabinetS20Test {

    private jsonData = {
        "$id": "1",
        "CabinetShape": {
            "D1": "575",
            "DC": "0",
            "Depth": "910",
            "Height": "768",
            "Orientation": 3,
            "Shape": 10,
            "TypeName": "DrawS20CabinetShape",
            "W1": "575",
            "WC": "0",
            "Width": "910"
        },
        "Constants": {
            "$id": "2",
            "BoxThickness": "16",
            "CountertopHeight": "768",
            "DoorThickness": "20",
            "DrawerRailHeight": "100",
            "DrawerRecess": "100",
            "FixedShelfThickness": "20",
            "GapBetweenFrontElements": "4",
            "GapBottomBox": "2",
            "GapTopBox": "0",
            "GlassShelfThickness": "8",
            "GrooveGap": "34",
            "GrooveWidth": "60",
            "IsDefaultHeightConstant": true,
            "PlinthDepth": "56",
            "PlinthHeight": "115",
            "PulloutRailHeight": "200",
            "PulloutRecess": "100",
            "ShelfThickness": "16",
            "SideBoxGap": "2"
        },
        "ElementSubType": {
            "$id": "21",
            "Id": "7082f27e-2a1a-4b8b-bab2-898e2941c202",
            "Name": "Default CabinetBox"
        },
        "Fronts": [
            {
                "$id": "3",
                "Element": {
                    "$id": "5",
                    "Elements": [
                        {
                            "$id": "6",
                            "FrontElement": 1,
                            "Height": "732",
                            "OpeningOrientation": 0,
                            "OpeningType": 0,
                            "TypeName": "DrawFrontDoor",
                            "Width": "Auto"
                        },
                        {
                            "$id": "7",
                            "FrontElement": 8,
                            "Height": "34",
                            "TypeName": "DrawFrontHorizontalGroove",
                            "Width": "Auto"
                        }
                    ],
                    "Height": "Auto",
                    "TypeName": "DrawCabinetFrontElementGroup"
                },
                "Faces": [
                    {
                        "$id": "4"
                    }
                ]
            },
            {
                "$id": "8",
                "Element": {
                    "$id": "10",
                    "Elements": [
                        {
                            "$id": "11",
                            "FrontElement": 1,
                            "Height": "732",
                            "Inside": {
                                "$id": "12",
                                "SubElements": [
                                    {
                                        "$id": "13",
                                        "Anchor": {
                                            "$id": "15",
                                            "AnchorType": 9
                                        },
                                        "Depth": "Auto",
                                        "Face": {
                                            "$id": "14",
                                            "Index": 3
                                        },
                                        "Height": "Auto",
                                        "Offset": {
                                            "$id": "16",
                                            "OffsetType": 2
                                        },
                                        "OpeningAnimation": 1,
                                        "Type": 12,
                                        "TypeName": "DrawInsideTray",
                                        "Width": "Auto"
                                    },
                                    {
                                        "$id": "17",
                                        "Anchor": {
                                            "$ref": "15"
                                        },
                                        "Depth": "Auto",
                                        "Face": {
                                            "$ref": "14"
                                        },
                                        "Height": "Auto",
                                        "Offset": {
                                            "$ref": "16"
                                        },
                                        "OpeningAnimation": 1,
                                        "Type": 12,
                                        "TypeName": "DrawInsideTray",
                                        "Width": "Auto"
                                    }
                                ],
                                "TypeName": "DrawCabinetInsideGroupElement"
                            },
                            "OpeningOrientation": 0,
                            "OpeningType": 0,
                            "TypeName": "DrawFrontDoor",
                            "Width": "Auto"
                        },
                        {
                            "$id": "18",
                            "FrontElement": 8,
                            "Height": "34",
                            "TypeName": "DrawFrontHorizontalGroove",
                            "Width": "Auto"
                        }
                    ],
                    "Height": "Auto",
                    "TypeName": "DrawCabinetFrontElementGroup"
                },
                "Faces": [
                    {
                        "$id": "9",
                        "Index": 1
                    }
                ]
            }
        ],
        "Id": "b6bbb064-10b0-4b5a-9e1c-5783a2661883",
        "ProviderRef": "UEY 91-76-03-P",
        "Range": {
            "$id": "19",
            "Id": "851ff66b-f33b-47c1-a4f7-f6461336648b",
            "IsWithGaps": true,
            "Name": "Y-Line"
        },
        "Shape": {
            "$id": "22",
            "D1": "575",
            "DC": "0",
            "Depth": "910",
            "Height": "768",
            "Orientation": 3,
            "Shape": 10,
            "TypeName": "DrawS20CabinetShape",
            "W1": "575",
            "WC": "0",
            "Width": "910"
        },
        "SubFinish": {
            "$id": "20",
            "Id": "64fbbe0b-0a97-413e-86ef-af2d71b99430"
        },
        "TypeName": "DrawCabinet"
    };


    getCabinet() : CabinetObject | undefined {
        let drawCabinet = this.getDrawCabinet();

        const generator = CabinetGeneratorFactory.GetGenerator(drawCabinet);
        const cabinetObject = generator?.BuildCabinet();

        return cabinetObject;
    }

    getDrawCabinet(): DrawCabinet {

        const deserializedObject = plainToClass(DrawCabinet, this.jsonData);

        return deserializedObject;
    }

}